export const COLUMNS = [
  {
    header: "Full Name",
    accessor: "full_name",
  },
  {
    header: "Email",
    accessor: "email",
  },
  {
    header: "Company Size",
    accessor: "size",
  },
  {
    header: "Goals",
    accessor: "goals",
  },
];
